export default {
  formatHumanReadableDate(date, lang = "fr") {
    if (typeof date !== "object" || !(date instanceof Date))
      date = new Date(date);
    const formatter = new Intl.DateTimeFormat(lang, { month: "long" });
    return `${date.getDate()} ${formatter.format(date)} ${date.getFullYear()}`;
  }
};
